import { render, staticRenderFns } from "./SearchResultsDashboard.vue?vue&type=template&id=4669848a&"
import script from "./SearchResultsDashboard.vue?vue&type=script&lang=ts&"
export * from "./SearchResultsDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports